import { mutation_add_user_tenant, mutation_update_user_tenant, mutation_update_user_tenant_Type } from "../../businessLogic/mutations/userTeantMutations";
import { query_get_all_user_tenant } from "../query/userTenantQueries";
import { useMutation } from "@1f/react-sdk";
import { LogApi } from "../../businessLogic/api/logApi";

export const UserTenantApi = () => {
    const logApi = LogApi();
    const apiAddUserTenant = useMutation(mutation_add_user_tenant, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiUpdateUserTenant = useMutation(mutation_update_user_tenant, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    }); 
    const apiUpdateUserTenantType = useMutation(mutation_update_user_tenant_Type, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apigGetAllUserTenant = useMutation(query_get_all_user_tenant, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    })  
    const GetAllUserTenant = async (tenantId) => {
        try {
            let allUserTenantResponse = await apigGetAllUserTenant.fetch({
                tenantId: tenantId
            });
            if(allUserTenantResponse){
                return allUserTenantResponse.data.data.user_tenant
            }
        } catch (error){
            throw new Error(`Impossibile recuperare le associazioni user_tenant per il tenant ${tenantId}` + error.message);
        }
    }
    const PostUserTenant = async (userTenantToAdd) => {
        try {
            let addUserTenantResponse = await apiAddUserTenant.fetch({
                tenantId: userTenantToAdd.tenantId,
                userId: userTenantToAdd.userId,
                type: userTenantToAdd.type,
                tenantTipoId: userTenantToAdd.tenantTipoId,
            });
            if(addUserTenantResponse){
                logApi.AddLog(`Associazione tra utente ${userTenantToAdd.userId} e tenant ${userTenantToAdd.tenantId} aggiunta con successo`, "", "loadAndSyncUserFromTsDigital/PostUserTenant", "Dashboard", "INFO");
                return true
            }
        } catch (error) {
            throw new Error(`Impossibile aggiungere l'assiociazione user_tenant: ${userTenantToAdd.userId + " - " +userTenantToAdd.tenantId}` + error.message);
        }
    }
    const UpdateUserTenant = async (itemTenant,userToUpdate) => {
        try{
            const tenantId = itemTenant.TenantId ?? itemTenant.tenantId;
            const userId = itemTenant.UserId ?? itemTenant.userId;
            let updateUserTenantResponse  = await apiUpdateUserTenant.fetch({
                tenantId: tenantId,
                userId: userId,
                tenantTipoId: userToUpdate.tenantTipoId,
                type: userToUpdate.type
            })
            if(updateUserTenantResponse){
                logApi.AddLog(`Utente ${userId} aggiornato correttamente sul tenant ${tenantId}`, "", "UpdateUserTenant", "Dashboard");
                return true
            }
        } catch(error){
            throw new Error(`Impossibile aggiornare l'associazione user_tenant ${itemTenant.tenantId + " - " + itemTenant.userId}` + error.message)
        }
    } 
    const UpdateUserTenantType = async (itemTenant,userToUpdate) => {
        try{
            const tenantId = itemTenant.TenantId ?? itemTenant.tenantId;
            const userId = itemTenant.UserId ?? itemTenant.userId;
            let updateUserTenantResponse  = await apiUpdateUserTenantType.fetch({
                tenantId: tenantId,
                userId: userId,                        
                type: userToUpdate.type
            })
            if(updateUserTenantResponse){
                logApi.AddLog(`Tipo dell'utente ${userId} aggiornato correttamente sul tenant ${tenantId}`, "", "UpdateUserTenantType", "Dashboard");
                return true
            }
        } catch(error){
            throw new Error(`Impossibile aggiornare il campo type sull'utente ${itemTenant.userId} del tenant ${itemTenant.tenantId}` + error.message)
        }
    }
    return {
        GetAllUserTenant,
        PostUserTenant,
        UpdateUserTenant,
        UpdateUserTenantType,
    }
}